module.exports = __webpack_public_path__ + "img/Componente 45 – 1.dbdea153.svg";